































































































































import { Vue, Component } from "vue-property-decorator";
import { Swipe, SwipeItem, Switch, Search, Empty, DropdownMenu, DropdownItem } from "vant";
import { BusinessType, ServiceType, categoryMap, OrderStatus } from "@/model/Base";
import workService from "@/service/workService";
import moment from "moment";
import * as _ from "lodash";
import { parseOrder, filterFeatureCodes } from "./order/orderUtils";
import dataShare from "./mall/dataShare";
import adapterService from "@/service/adapterService";
import { loadLanguageAsync } from "@/lang/index";
import UserService from "@/service/UserService";
import btripServcice from "@/service/btripServcice";
import { result } from "lodash";
export class WarnInfo {
  title: string;
  message: string;
  isShowTel: boolean = false;
  constructor(title: string, message: string) {
    this.title = title;
    this.message = message;
  }
}

declare type majorCode = "flight" | "hotel" | "train" | "traffic";

@Component({
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Switch.name]: Switch,
    [Search.name]: Search,
    [Empty.name]: Empty,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
})
export default class extends Vue {
  // aImg = require("../../static/img/swipe01.png");
  // bImg = require("../../static/img/swipe02.png");
  // cImg = require("../../static/img/swipe03.png");
  aImg = require("../../static/img/banner01.jpg");
  bImg = require("../../static/img/banner02.jpg");
  cImg = require("../../static/img/banner03.jpg");
  images = [this.aImg, this.bImg, this.cImg];
  serchVal = "";
  works: any = [];

  serviceMaps = {
    flight: {
      Path: "/mall/flight",
      ConferID: "S00008446255",
      isSubscribe: true,
      ServiceID: "S00000000009",
      ServiceName: "国内机票",
      ServiceType: 1409,
      ApplyArea: 1126,
    },
    hotel: {
      Path: "/mall/hotel",
      ConferID: "S00008446257",
      isSubscribe: true,
      ServiceID: "S00000000013",
      ServiceName: "国内酒店",
      ServiceType: 1407,
      ApplyArea: 1126,
    },
    train: {
      Path: "/mall/train",
      ConferID: "S00008446259",
      isSubscribe: true,
      ServiceID: "S00000000017",
      ServiceName: "国内火车",
      ServiceType: 1470,
      ApplyArea: 1126,
    },
    traffic: {
      Path: "/mall/traffic/taxi",
      isSubscribe: false,
      ServiceID: "S00000000029",
      ServiceName: "用车服务",
      ServiceType: 1555,
      ApplyArea: 1126,
    },
  };

  created() {
    this.getIndexImgs();
  }
  mounted() {
    // this.getWorksData();
    this.checkService();
  }
judgeCompany(profile:any){
  return profile && (profile.CompanyID === 'S00010572077' || profile.CompanyName === '昆翎企业管理（上海）有限公司')
}
  restModel() {
    this.where = {
      PageNo: 0,
      PageSize: 99999,
      RecordCount: 15,
      BusinessTypes: [1797, 1789],
      ServiceTypes: [1409, 1407, 1470, 1408],
    };
    return this.where;
  }
  fliterCode: string = "recenttrip";
  isCheckOption(code: string) {
    return this.fliterCode == code;
  }
  changeStatus(id: string) {
    var model = this.restModel() as any;
    if (id == "waitapproval") {
      model.BusinessTypes = [1797, 1789, 1799];
      model.BusinessStatuss = [10107, 10205];
      model.ActiveUserID = this.profile.UserID;
    } else if (id == "waitpayment") {
      // model.BusinessTypes = [1797, 1789];
      model.BusinessStatuss = [10107];
    } else if (id == "myorder") {
      // model.BusinessTypes = [1797, 1789];
      model.BusinessStatus = "10113";
      model.CreateUserID = this.profile.UserID;
    } else if (id == "recenttrip") {
      model.TaskDate = moment().format("YYYY-MM-DD");
      model.TaskDateEnd = moment()
        .add(5, "days")
        .format("YYYY-MM-DD");
      model.BusinessStatus = "10113";
      model.CreateUserID = this.profile.UserID;
    }

    model.CreateTime = moment()
      .subtract(3, "months")
      .format("YYYY-MM-DD");
    model.ServiceTypes = [1409, 1407, 1470, 1408];

    this.fliterCode = id as any;
    this.getWorksData();
  }


  checkService() {
    let __self = this;
    UserService.getServiceList().then(response => {
      if (!response.isSucc || !response.result) {
        return;
      }
      for (const key in this.serviceMaps) {
        if (Object.prototype.hasOwnProperty.call(this.serviceMaps, key)) {
          const service = this.serviceMaps[key as majorCode];
          service.isSubscribe = response.result.some((o: any) => o.ServiceType == service.ServiceType && o.isSubscribe);
        }
      }

      btripServcice.getTripRule({ Users: [] } as any).then((res: any) => {
        if (res.isSucc && res.result && res.result.ApprovalRule) {
          let approvalRule = res.result.ApprovalRule;
          if (approvalRule.indexOf("1591") > -1) {
            __self.serviceMaps.flight.isSubscribe = false;
          }
          if (approvalRule.indexOf("1593") > -1) {
            __self.serviceMaps.hotel.isSubscribe = false;
          }
          if (approvalRule.indexOf("1595") > -1) {
            __self.serviceMaps.train.isSubscribe = false;
          }
        }
      });
    });
  }
  //获取首页轮播图
  getIndexImgs() {
    let data = { ExtraCode: "App-Round-Image" };
    adapterService.getIndexExtras(data).then((res: any) => {
      if (res.isSucc) {
        this.images = res.result.map((item: any) => item.ExtraData);
      }
    });
  }
  survey() {
    if (!dataShare.realIndex) {
      dataShare.realIndex = history.length;
    } else {
      history.pushState({ indexSurvey: "indexSurvey" }, "index", "/");
      let distance = dataShare.realIndex - history.length;
      // console.log(`index:${dataShare.realIndex} survey:${history.length} distance:${distance}`);
      if (distance != 0) {
        dataShare.indexSurvey = true;
        history.go(distance);
      }
    }
  }

  activated() {
    this.changeStatus('recenttrip');
    // this.getWorksData();
    // this.survey();
    // this.num = 0;
  }
  formatDate(value: Date, format: string = "YYYY-MM-DD HH:mm") {
    return (this as any).$moment(value).format(format);
  }

  where = {};

  getWorksData() {
    const __self = this;
    workService.List(this.where).then((res: any) => {
      if (res.isSucc) {
        const entities = res.result.entities;
        const cleanData = _.remove(entities, (item: any) => item.ServiceType == 1410 || item.ServiceType == 1466);

        const orderMap: any = {};
        _.forEach(entities, (ent: any) => {
          if (!ent || ent.TripOrder || ent.BusinessType != BusinessType.Sales) {
            return;
          }
          _.forEach(cleanData, (el: any) => {
            if (el.UnionID == ent.UnionID && ent.UnionID && ent.UnionID != "") {
              ent.PaymentAmount += el.PaymentAmount;
              ent.ReceiveAmount += el.ReceiveAmount;
            }
          });
          let orders = parseOrder(ent);
          if (orderMap[ent.OrderID]) {
            _.forEach(orderMap[ent.OrderID], o => orders.push(o));
          }
          orderMap[ent.OrderID] = _.orderBy(orders, o => o.UniqueID);
        });
        let works = [];
        for (const key in orderMap) {
          if (orderMap.hasOwnProperty(key)) {
            works.push(orderMap[key]);
          }
        }
        __self.works = works;
      }
    });
  }
  showToast() {
    this.$root.$toast(this.$root.$t("index_jijiangchengxian") as string);
  }
  btnClick(lang: string): void {
    this.$i18n.locale = lang;
  }
  onSearch() {
    this.$root.$toast(this.$root.$t("index_ditugongnengkaifazhong") as string);
  }
  imgSrc(code: number): string {
    const flightPage = require("../../static/img/flightPage.png");
    const hotelPage = require("../../static/img/hotelPage.png");
    const tarinPage = require("../../static/img/trainPage.png");
    if (code == 1407) {
      return hotelPage;
    } else if (code == 1409) {
      return flightPage;
    } else {
      return tarinPage;
    }
  }
  serviceName(code: number): string {
    if (code == 1407) {
      return this.$root.$t("index_jiudian") as string;
    } else if (code == 1409) {
      return this.$root.$t("index_jipiao") as string;
    } else {
      return this.$root.$t("index_huochepiao") as string;
    }
  }

  filterFeatureCodes(order: any) {
    return filterFeatureCodes(order.FeatureCodes, order.ServiceType, order);
  }
  isApproval(value: any) {
    return value.ClientOrderStatus == OrderStatus.WaitPayment && value.ClientStatusName != name;
  }
  gotoOrderDetails(order: any) {
    this.$router.push({
      path: "/order/details",
      query: {
        OrderID: order.OrderID,
        ServeType: order.ServiceType,
      },
    });
  }

  goto(code: majorCode) {

    // 用车服务
    // if(code === 'traffic'){
    //   const thirdPartyUrl = "https://test-now.heycars.cn/heycarsapp/#/home?utm_source=lichengtrip&data=FOSBj4IhsQeuuKGIRRyCjKS%2BjTKGgsN41kFa21ApZBT2AH9MRFQgHwQmLI3OvGzyCGxtSgT%2FC58Pa2gUENes86pIBQgQjKF7RIFMvLswVQlidDhRvYBlxh2Ptk3afcUGlqDT7qg%2Fb%2BpF9m%2BCzxnrYjohyZdWW3ExdGoT4vsnUsFlBUaTm5%2FyZiTDkqsKpDlAX5xFoLyc%2Bra3VB4KE6%2Bmwgr1YcUNwqSu0S8QxoeWYG3p8MKl1ZPVuw%3D%3D"
    //     if (window.NativeBridge?.openWebView) {
    //       window.NativeBridge.openWebView({
    //         url: thirdPartyUrl,
    //         title: '用车服务'
    //       })
    //     }else{
    //       window.location.href = thirdPartyUrl
    //     }
    //     return;
    // }
    
    var service = this.serviceMaps[code];
    if (service.isSubscribe) {
      this.$router.push(service.Path);
      return;
    }

    // var warnInfo = new WarnInfo("服务提醒", `暂不提供${service.ServiceName.replace("火车", "火车票")}商旅预定服务!`);
    var warnInfo = new WarnInfo("服务提醒", `此商旅服务功能暂未签约，需要签约后，才可为贵司提供服务，期待早日为您服务！`);
    // if (code == "traffic") {
    //   warnInfo = new WarnInfo("力程商务用车", "企业用车服务正在加紧测试当中，如有需要可联系客服预约，完善合同参与试用体验");
    //   warnInfo.isShowTel = true;
    // }
    this.warnInfo = warnInfo;
  }

  get isShowWarn() {
    return this.warnInfo != null;
  }
  set isShowWarn(value) {
    this.warnInfo = null;
  }
  warnInfo: WarnInfo | null = null;
}
